import { render } from "./CreateSlider.vue?vue&type=template&id=9d12cc46"
import script from "./CreateSlider.vue?vue&type=script&lang=js"
export * from "./CreateSlider.vue?vue&type=script&lang=js"

import exportComponent from "E:\\laragon\\www\\RDRS_Union_Federation\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__